import { render, staticRenderFns } from "./ElectricChart.vue?vue&type=template&id=5622085e&"
import script from "./ElectricChart.vue?vue&type=script&lang=js&"
export * from "./ElectricChart.vue?vue&type=script&lang=js&"
import style0 from "./ElectricChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports